import React, { useState } from "react"
import Drawer from "react-modern-drawer"
import "react-modern-drawer/dist/index.css"
import Link from "next/link"
import Image from "next/image"
import { GiHamburgerMenu } from "react-icons/gi"
import { AiOutlineClose } from "react-icons/ai"
import {
  useTranslation,
  useLanguageQuery,
  LanguageSwitcher,
} from "next-export-i18n"
const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()
  const [query] = useLanguageQuery()
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState)
  }
  const [isProductMenu, setIsProductMenu] = useState(false)
  const toggleDropdownProduct = () => setIsProductMenu(!isProductMenu)

  return (
    <div>
      <div className="flex justify-between bg-white z-50 h-20 fixed left-0 right-0 top-0 py-5 shadow-xl">
        <div className="pl-5">
          <Link href={{ pathname: "/", query: query }}>
            <a>
              <Image
                src="/images/ERVCClogo.png"
                width={210}
                height={50}
                alt="ERVCC logo"
              />
            </a>
          </Link>
        </div>
        <div className="pr-5 self-center cursor-pointer">
          <span onClick={toggleDrawer}>
            <GiHamburgerMenu className="w-8 h-8" />
          </span>
        </div>
      </div>
      <Drawer
        open={isOpen}
        onClose={toggleDrawer}
        direction="left"
        size={"85vw"}
      >
        <div className="flex justify-between pl-5 pt-7">
          <Link href="/" passHref>
            <Image
              src="/images/ERVCClogo.png"
              width={200}
              height={48}
              alt="ERVCC logo"
            />
          </Link>
          <div className="flex-col pr-5">
            <span className="">
              <AiOutlineClose
                className="w-8 h-8 pl-3 pb-3 float-right cursor-pointer"
                onClick={toggleDrawer}
              />
            </span>
            <div className="">
              <LanguageSwitcher lang="en">EN</LanguageSwitcher> |{" "}
              <LanguageSwitcher lang="fr">FR</LanguageSwitcher>
            </div>
          </div>
        </div>
        <div className="flex flex-col pt-10 px-6">
          <a className="text-lg text-dark transition-all hover:text-secondary py-3.5 border-b border-grey">
            {t("open_7_days_a_week")}
          </a>

          <Link
            href={{
              pathname: t("register_for_a_phone_or_video_call_here.route"),
              query: query,
            }}
          >
            <a className="text-lg text-dark transition-all hover:text-secondary py-3.5 border-b border-grey">
              {t("register_for_a_phone_or_video_call_here.text")}
            </a>
          </Link>
        </div>
      </Drawer>
    </div>
  )
}

export default MobileMenu
